import React from 'react'
import { Link } from 'react-router-dom'
import moment from 'moment'

import { TCallCancelledBy } from '../../../../context/types'

export type CancelledCallAlertProps = {
	cancelledBy: TCallCancelledBy
	cancelledOn: string
	tz?: string
}

export const CancelledCallAlert = ({ cancelledBy, cancelledOn, tz }: CancelledCallAlertProps) => {
	const cancelledByFullName = `${cancelledBy.first_name} ${cancelledBy.last_name}`

	return (
		<>
			<span>The call was canceled by </span>

			<b>
				{cancelledBy.isExpert ? (
					<Link to={`/expert/${cancelledBy.expert_slug}`}>{cancelledByFullName}</Link>
				) : (
					cancelledByFullName
				)}
			</b>

			<span> on {moment(cancelledOn).tz(tz).format('MMMM D, YYYY [at] h:mm A')}</span>
		</>
	)
}
